// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "aside .v-list-item__title a{text-transform:capitalize}.v-btn--plain:not(.v-btn--active):not(.v-btn--loading):not(:focus):not(:hover) .v-btn__content{opacity:1}section.navbar-drawer-section{position:static;display:contents}", ""]);
// Exports
module.exports = exports;
